var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M208.789,29.972l31.819,31.82L91.763,210.637L0,118.876l31.819-31.82l59.944,59.942L208.789,29.972z"}));
}

Check.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 240.608 240.608","style":{"enableBackground":"new 0 0 240.608 240.608"},"xmlSpace":"preserve"};

module.exports = Check;

Check.default = Check;
